(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mp-anchor-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var anchor = event.target.closest('[data-mp-anchor-link]');
    if (!anchor) return;

    var targetId = anchor.getAttribute('data-mp-anchor-link');
    var targetEl = document.getElementById(targetId)
      || document.getElementById('shopify-section-' + targetId);

    if (targetEl) {
      event.preventDefault();
      var offset = parseInt(anchor.getAttribute('data-mp-anchor-offset'), 10) || 0;
      var top = targetEl.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
